import { render } from "./ViewProfileComp.vue?vue&type=template&id=3578c10e&scoped=true"
import script from "./ViewProfileComp.vue?vue&type=script&lang=js"
export * from "./ViewProfileComp.vue?vue&type=script&lang=js"

import "./ViewProfileComp.vue?vue&type=style&index=0&id=3578c10e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3578c10e"]])

export default __exports__